$(document).ready(function(){
	
	// $(document).on('change','#busca-modelo-marca select',function(){
	// 	var id = parseInt($(this).val());
	// 	var passo = parseInt($(this).attr('data-passo'));

	// 	// if(isNaN(id)){
	// 	// 	id = -1;
	// 	// }else{
	// 	// 	pageLoadingOn();	
	// 	// } 
		
	// 	// $("#busca-modelo-modelo select").remove();
	// 	// getFiltros(id,passo);
		
	// 	$('.passo'+passo).val(id);
	// });

	$(document).on('change','#busca-modelo-carro select',function(){
		carro = $(this).val();
		$("#carro").val(carro);
	});
	$(document).on('change','#busca-modelo-modelo select',function(){
		modelo = $(this).val();
		$("#modelo").val(modelo);
	});
	$(document).on('change','#busca-modelo-ano select',function(){
		ano = $(this).val();
		$("#ano").val(ano);
	});
	
	// Função para buscar os anos do modelo selecionado
	// $('body').on('change','#busca-modelo-modelo select',function(){
	// 	var id = parseInt($(this).val());
	// 	var passo = parseInt($(this).parent().attr('data-passo'));
	// 	var carro = parseInt($('#carro').val());
	// 	var modelo = '';
		
	// 	if(!(isNaN(passo)) && passo != 3){
	// 		// if(isNaN(id)){
	// 		// 	id = -1;
	// 		// }else{
	// 		// 	pageLoadingOn();	
	// 		// } 
			
	// 		// // Resetar campo Ano
	// 		// var passo_tmp = passo + 1;
	// 		// $('#busca-modelo-modelo div[data-passo='+passo_tmp+'] .filtro-options').remove();
			
	// 		// // Resetar campo Motores 
	// 		// if(passo_tmp < 3){
	// 		// 	passo_tmp++;
	// 		// 	$('#busca-modelo-modelo div[data-passo='+passo_tmp+'] .filtro-options').remove();
	// 		// }
			
	// 		if(passo == 2){
	// 			modelo = $(this).val();
	// 			$("#modelo").val(modelo);
	// 		}
			
	// 		//console.log(carro, id, passo, modelo);
	// 		// getFiltros(id, passo, carro, modelo);	
	// 	}
	// });
  
	$('#busca-modelos #submitBtn').on('click',function(){
		var arr = $('#filtro').val();
		var carro = parseInt($('#carro').val());
		var modelo = parseInt($('#modelo').val());
		var ano = parseInt($('#ano').val());

		// Verificação se o filtro selecionado é todos é todos
		var ano_todos = $('#ano option:selected').text().toLowerCase();
		
		
		if(!isNaN(carro)) 	{ arr = carro; }
		if(!isNaN(modelo)) 	{ arr += "_" + modelo; }
		if(!isNaN(ano) && ano_todos != 'todos') { arr += "_" + ano; }

		$('#filtro').val(arr);
		
		var validacao = validateForm($('#busca-modelos'));
		
		if(!validacao){
			return false;
		}

		if(!isNaN(carro)){
			$('#busca-modelos').submit();		
		}
	});
});

//function getFiltros(id, passo, carro, modelo){
// function getFiltros(id, passo, carro, modelo){
// 	if(carro == undefined){ carro = ''; }
// 	if(modelo == undefined){ modelo = ''; }
// 	$.ajax({
// 		url: "/filtros/",
// 		type: "GET",
// 		data: "id="+id+"&passo="+passo+"&carro="+carro+"&modelo="+modelo,
// 		// data: "id="+id+"&passo="+passo+"&carro="+carro,
// 		dataType:"json",
// 		success: function(json){
// 			var proximo = parseInt(passo)+1;
// 			$('.passo'+proximo).html(json.html);
// 			pageLoadingOff();
// 		}
// 	});
// };